import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage ,transformResponse} from "../baseQuery";

export const AuthApiSlice = createApi({
  reducerPath: "AuthApiSlice",
  baseQuery,

  tagTypes: ["auth", "myprofile"],

  endpoints: (builder) => ({
    uploadprofileImageApi: builder.mutation({
      query: (datas) => ({
        url: `api/auth/uploadprofileImage`,
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["auth"],
    }),

    loginApi: builder.mutation({
      query: (values) => ({
        url: "api/auth/signin",
        method: "POST",
        body: values,
      }),
      transformResponse,
      transformErrorResponse: transformErrorResponseWithMessage,
    }),

    signupApi: builder.mutation({
      query: (values) => ({
        url: "api/auth/signup",
        method: "POST",
        body: values,
      }),
      transformResponse,
      transformErrorResponse: transformErrorResponseWithMessage,
    }),

    signoutApi: builder.mutation({
      query: () => ({
        url: `api/auth/signout`,
        method: "POST",
      }),
      transformResponse,
      transformErrorResponse,
    }),

    getUserApi: builder.query({
      query: () => ({
        url: "api/auth/getUser",
        method: "GET",
      }),
      transformResponse,
      transformErrorResponse,
      providesTags: ["myprofile"]
    }),

    changePasswordApi: builder.mutation({
      query: (values) => ({
        url: "api/auth/changePassword",
        method: "POST",
        body: values,
      }),
      transformResponse,
      transformErrorResponse,
    }),

    editUserApi: builder.mutation({
      query: (values) => ({
        url: "api/auth/editUser",
        method: "PUT",
        body: values,
      }),
      transformResponse,
      transformErrorResponse,
      invalidatesTags: ["myprofile"],
    }),
  }),
});

export const {
  useUploadprofileImageApiMutation,
  useLoginApiMutation,
  useSignupApiMutation,
  useSignoutApiMutation,
  useGetUserApiQuery,
  useChangePasswordApiMutation,
  useEditUserApiMutation,
} = AuthApiSlice; 